var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main-container"},[_c('Sidebar'),_c('el-container',{attrs:{"direction":"vertical"}},[_c('Header'),_c('el-main',[_vm._t("default")],2),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }